let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6GiE8")).then(() => parcelRequire('78iVy'));